import {Component, Inject} from '@angular/core'
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog'

export interface ApprovalDialogData {
  jira: string
  comment: string
}

@Component({
  selector: 'app-approval-dialog',
  templateUrl: 'approval-dialog.component.html',
  styleUrls: ['./approval-dialog.component.scss'],
})
export class ApprovalDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ApprovalDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: ApprovalDialogData) {
  }

  cancel() {
    this.dialogRef.close(undefined)
  }
}
